export const PHONE_NUMBER = "(513) 734-8757"
export const EMAIL = "info@refineship.com"
export const ADDRESS = `"5718 Richmond Park Drive, Mason, OH, 45040, USA "`
export const ADDRESS_LINK = "https://maps.app.goo.gl/EpMhpuP7ZBPhpA5a6"
